module.exports = __webpack_public_path__ + "static/media/pn.a2911b5b.svg";